import { WorkbookForCreate, WorkbookParams } from "@/store/analytics/dasboards";
import { formatDateToYYYYMMDD } from "../utils/DateParser";

export function areWorkbookFieldsValid(workbook: WorkbookForCreate): boolean {

    if (!workbook.client_workbook.name || !workbook.client_workbook.organization_id || !workbook.client_workbook.token) {
        return false;
    }
    for (const dashboard of workbook.dashboards) {
        if (!dashboard.name || !dashboard.datalens_id) {
            return false;
        }
    }

    return true;
}

export function setWorkbooksParamsByFilter(params: WorkbookParams, settings: TableSettings) {
    if (settings.orderField) {
        params.order_by = settings.orderField;
    } else {
        params.order_by = '-mtime';
    }

    if (settings.commonFilter) {
        params.name__ilike = settings.commonFilter;
    }

    if (Object.keys(settings.filter).length > 0) {
        if (typeof settings.filter.include_demo === "boolean") {
            params.include_demo = settings.filter.include_demo;
        }

        if (settings.filter.name) {
            params.name__ilike = settings.filter.name;
        }

        if (settings.filter.datalens_id) {
            params.dashboards__datalens_id = settings.filter.datalens_id;
        }

        if (settings.filter.user.length > 0) {
            params.cuser__id__in = settings.filter.user.join(",");
        }

        if (settings.filter.organization.length > 0) {
            params.organization_id__in = settings.filter.organization.join(",");
        }

        if (settings.filter.include_to_demo_accounts.length > 0) {
            params.include_to_demo_accounts = settings.filter.include_to_demo_accounts == "1" ? true : false;
        }

        if (settings.filter.cdate)
            params.cdate = formatDateToYYYYMMDD(settings.filter.cdate);

        if (settings.filter.mdate)
            params.mdate = formatDateToYYYYMMDD(settings.filter.mdate);

    }
}

interface TableSettings {
    first: number;
    orderField: string;
    commonFilter: string;
    filter: FilterForm;
}

export interface FilterForm {
    include_demo?: boolean;
    name: string;
    datalens_id: string;
    cdate: Date | null;
    mdate: Date | null;
    user: number[];
    organization: number[];
    include_to_demo_accounts: string;
}